import React, { useEffect, useState } from "react";
import Main from "../../../layout/main/Main";
import { Link, useSearchParams } from "react-router-dom";
import {
	ButtonContainer,
	ChildrenContainer,
	AntdButton,
	PageContainer,
	PageHeaderBlock,
	TitleBlock,
	PageTitle,
	PageSub,
	ContentShell,
} from "./styles";
import ClientsList from "./list/ClientsList";
import { get_client_list_dapper } from "../../../../api/endpoints/clients";

export default function MarketClientsIndex() {
	const [filter, setFilter] = useState("LABORATORIES");
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");

	const get_filter = () => {
		setFilter(
			localStorage.getItem("marketClientsIndexFilter")
				? localStorage.getItem("marketClientsIndexFilter")
				: "LABORATORIES",
		);
	};

	useEffect(() => {
		window.scrollTo(0, 0);
		get_filter();
	}, []);

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						{uri ? (
							<Link to={"/" + uri}>Configuración General</Link>
						) : (
							<Link to="/">Home</Link>
						)}
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Clientes</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>
			<Main.Body>
				<PageContainer>
					<PageHeaderBlock>
						<TitleBlock>
							<PageTitle>
								{filter === "LABORATORIES" ? "Laboratorios" : "Farmacias"}
							</PageTitle>
							<PageSub>
								Gestioná{" "}
								{filter === "LABORATORIES"
									? "los laboratorios"
									: "las farmacias"}{" "}
								del sistema
							</PageSub>
						</TitleBlock>

						<ButtonContainer>
							<AntdButton
								$active={filter === "LABORATORIES"}
								onClick={() => setFilter("LABORATORIES")}
							>
								LABORATORIOS
							</AntdButton>

							<AntdButton
								$active={filter === "PHARMACIES"}
								onClick={() => setFilter("PHARMACIES")}
							>
								FARMACIAS
							</AntdButton>
						</ButtonContainer>
					</PageHeaderBlock>

					<ContentShell>
						<ChildrenContainer>
							{filter === "LABORATORIES" && (
								<ClientsList
									get_clients_page={get_client_list_dapper}
									clientType="LABORATORY"
									uri={uri}
								/>
							)}
							{filter === "PHARMACIES" && (
								<ClientsList
									get_clients_page={get_client_list_dapper}
									clientType="PHARMACY"
									uri={uri}
								/>
							)}
						</ChildrenContainer>
					</ContentShell>
				</PageContainer>
			</Main.Body>
		</Main>
	);
}
